import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export interface OfferRequest {
    signature?: string | null;
    expiryDateTime?: string | null;
    returnUrl?: string | null;
    callbackUrl?: string | null;
    partnerOrderIdentifier?: string | null;
    fixedAmount?: boolean | null;
    fixedCurrency?: boolean | null;
    fixedPaymentMethod?: boolean | null;
    showWalletAddress?: boolean | null;
}

export const defaultOfferRequest: OfferRequest = Object.freeze({
    signature: null,
    returnUrl: null,
    callbackUrl: null,
    partnerOrderIdentifier: null,
    expiryDateTime: null,
    fixedAmount: false,
    fixedCurrency: false,
    fixedPaymentMethod: false,
    showWalletAddress: true
});

export const useOfferStore = defineStore('offer', () => {
    const request = ref<OfferRequest>(defaultOfferRequest);
    const uuid = ref<string | null>(null);
    const requiredParametersProvided = ref<boolean>(false);

    function setOfferRequest(offerRequest: OfferRequest): void {
        if (!offerRequest) {
            reset();
            return;
        }

        request.value = Object.assign({}, defaultOfferRequest, offerRequest);
    }

    function setOfferUuid(id: string): void {
        uuid.value = id ?? null;
    }

    function setRequiredOfferParametersProvided(provided: boolean): void {
        requiredParametersProvided.value = provided;
    }

    function reset(): void {
        request.value = defaultOfferRequest;
        uuid.value = null;
        requiredParametersProvided.value = false;
    }

    return {
        offerRequest: computed<OfferRequest>(() => request.value),
        offerUuid: computed<string>(() => uuid.value),
        requiredParametersProvided: computed<boolean>(() => requiredParametersProvided.value),
        setOfferRequest,
        setOfferUuid,
        setRequiredOfferParametersProvided,
        reset
    };
});
